<template>
	<section>
		<!--列表-->
		<el-table :data="datalist" border stripe highlight-current-row v-loading="listLoading" style="width:90%;" height="600">
			<el-table-column prop="entime" label="时间" min-width="100"></el-table-column>
			<el-table-column prop="alis_index" label="编号" min-width="100">
				<template slot-scope="scope"><span v-html="formateData(scope.row)"></span></template>
			</el-table-column>
			<el-table-column prop="sites" label="Site" min-width="200">
				<template slot-scope="scope"><span v-html="formateSites(scope.row)"></span></template>
			</el-table-column>
		</el-table>
	</section>
</template>
<script>
	import util from '../../common/js/util'
	import { getListPage, delData, saveData } from '../../api/api';
	export default {
		data() {
			return {
				datalist: [],
				listLoading: false
			}
		},
		methods: {
			formateData:function(row){
				return (`<span style="color:${row.thecolor}">${row.alis_index}</span>`)
			},
			formateSites:function(row){
				return (`<span style="color:${row.thecolor}">${row.sites}</span>`)
			},
			getLists:function(){
				let para = {
					actionurl:'datas/getSiteList'
				};
				this.listLoading = true;
				getListPage(para).then((res) => {
					if(!util.checkLogOut(this,res.data)){
						this.total = res.data.total;
						this.datalist = res.data.datas;
					}
					this.listLoading = false;
				});
			}
		},
		mounted() {
			this.getLists();
		}
	}	
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// sitesinfo.vue?5b43ce0d